import invoiceStatus from '@/languages/ko-kr/invoice-status'
import taxStatus from '@/languages/ko-kr/tax-status'

export default {
  'change': '@:terms.change',
  'status': '@:terms.status',
  'cancel': '@:terms.cancel',
  'invoice': '@:terms.invoice',
  'bill': '@:terms.bill',
  'tax-free-invoice': '@:terms.tax-free-invoice',
  'tax-status': {
    ...taxStatus,
  },
  'invoice-status': {
    ...invoiceStatus,
  },
  'tax-description': {
    'pending': '@:terms.payment가 필요한 @:terms.tax@:terms.bill',
    'completed': '@:terms.payment한 @:terms.tax@:terms.bill',
    'processing': '@:terms.payment중인 @:terms.tax@:terms.bill',
    'invalid': '@:terms.payment 불가한 @:terms.tax@:terms.bill',
    'unavailable': '@:terms.due-date이 @:terms.time-over한 @:terms.tax@:terms.bill',
    'failed': '@:terms.payment @:terms.failed한 @:terms.tax@:terms.bill',
  },
  'invoice-description': {
    'excluded': '잘못 발행된 @:components.popup.change-status-popup.invoice',
    'completed': '@:terms.transfer한 @:components.popup.change-status-popup.invoice',
    'pending': '@:terms.transfer이 필요한 @:components.popup.change-status-popup.invoice',
    'processing': '@:terms.transfer중인 @:components.popup.change-status-popup.invoice',
    'invalid': '@:terms.transfer 불가한 @:components.popup.change-status-popup.invoice',
    'unavailable': '@:terms.transfer 불가한 @:components.popup.change-status-popup.invoice',
    'failed': '@:terms.transfer @:terms.failed한 @:components.popup.change-status-popup.invoice',
  }
}
